"use client";

import { useQuery } from "@tanstack/react-query";
import type { AppOverview } from "@/lib/app-detail/overview";

/** The header and information-card fields Sensor Tower shows for free: categories, top countries, ad libraries, links, release details. */
export function useAppOverview(appId: number, country: string) {
  const cc = (country || "us").toLowerCase();
  const { data, isLoading } = useQuery<AppOverview, Error>({
    queryKey: ["app-overview", appId, cc],
    enabled: !!appId,
    // The app_st and metadata rows refresh a few times a day at most.
    staleTime: 60 * 60 * 1000,
    queryFn: async () => {
      const res = await fetch(`/api/app-detail/overview?appId=${appId}&country=${cc}`);
      if (!res.ok) throw new Error("Failed to fetch app overview");
      return (await res.json()) as AppOverview;
    },
  });
  return { data: data ?? null, isLoading };
}
